<template>
	<div class="mi-wrap-content">
		<h2>{{ $t('miMoreInformation') }}</h2>
		<div class="mi-wrap-download">
			<p>bwHealthApp_OnePager.pdf</p>
			<button class="mi-download-btn" @click="downloadPDF">Download</button>
		</div>
		<div class="mi-wrap-sections">
			<About />
			<Organisation />
		</div>
	</div>
</template>

<script>
import About from './About.vue';
import Organisation from './Organisation.vue';
export default {
	name: 'MoreInformation',
	components: {
		About,
		Organisation,
	},
	methods: {
		downloadPDF() {
			window.open(`${process.env.BASE_URL}bwHealthApp_OnePager.pdf`, '_blank');
		},
	},
};
</script>

<style>
.mi-wrap-download {
	width: 100%;
}

.mi-wrap-download p {
	margin-bottom: 20px;
	font-size: 17px;
	text-align: center;
	color: var(--main-color-text-light);
}

.mi-wrap-download button {
	padding: 10px 30px;
	border-radius: 10px;
	text-decoration: none;
	color: var(--main-color-text-light);
	background-color: var(--main-color-dark);
	border: 2px solid var(--main-color-border-dark);
	cursor: pointer;
}

.mi-wrap-download button:hover {
	background-color: var(--main-color-light);
	color: var(--main-color-text-light);
}

.mi-wrap-content h2 {
	margin: 0px;
	padding: 30px 0px 0px 0px;
	font-size: 45px;
	color: var(--main-color-text-light);
	/* background-color: #ffffff80; */
}

.mi-wrap-sections h3 {
	font-size: 35px;
	color: var(--main-color-text-light);
}

.mi-wrap-sections ul {
	color: var(--main-color-text-light);
}

.mi-wrap-sections li {
	color: var(--main-color-text-light);
}

.mi-wrap-sections p {
	display: inline;
}

.mi-wrap-sections a {
	display: inline;
	color: var(--secondary-color-highlight);
}

.mi-wrap-sections a:visited {
	color: var(--secondary-color-highlight);
}

@media (pointer: none), (pointer: coarse) {
	.mi-wrap-content h2 {
		margin: 0px;
		padding: 30px 0px 0px 0px;
		font-size: 35px;
		color: var(--main-color-text-light);
		/* background-color: #ffffff80; */
	}

	.mi-wrap-sections h3 {
		font-size: 25px;
		margin: 15px auto !important;
		color: var(--main-color-text-light);
	}

	.mi-wrap-download button {
		margin-bottom: 10px;
	}
}
</style>
